import React from 'react';
import PropTypes from 'prop-types';
import './Section.css';

/* SECTION COMPONENT */

// const Section = ({ className, children }) => (
//   <div
//     className={
//       className ? `section ${className}` : 'section'
//     }
//   >
//     <div
//       className={
//         className
//           ? `section__inner ${className
//               .split(' ')
//               .map((c) => ` ${c}__inner`)}`
//           : 'section__inner'
//       }
//     >
//       {children}
//     </div>
//   </div>
// );

const Section = React.forwardRef(function Section(
  { className = '', children, ...rest },
  ref
) {
  const sectionClass = ['section', className].filter(Boolean).join(' ')
  const innerClasses = ['section__inner']
    .concat(
      className
        .split(' ')
        .filter(c => c)
        .map(c => `${c}__inner`)
    )
    .join(' ')

  return (
    <div ref={ref} className={sectionClass} {...rest}>
      <div className={innerClasses}>{children}</div>
    </div>
  )
})

Section.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

Section.defaultProps = {
  className: null,
  children: null,
};

export default Section;
